import {StompConfig} from '@stomp/ng2-stompjs';

const stompConfig: StompConfig = {
    url: process.env.OCR_STOMP_URI,
    headers: {},
    heartbeat_in: 0,
    heartbeat_out: 20000,
    reconnect_delay: 5000,
    debug: false
};

export default stompConfig;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/ocr/stomp.config.ts